import { createPortal } from "react-dom";
import Spinner from "./Spinner";
import { useBoundStore } from "@maxis/client-logic/store/useBoundStore";

/**
 * 전역 Spinner
 * useLoadingIndicator 훅을 이용해 제어
 */
const SpinnerOverlay = () => {
  const spinnerRoot = document.getElementById("spinner");
  // const { loading } = useLoadIndicatorStore();
  const loading = useBoundStore((state) => state.loadingIndicator.loading);

  return createPortal(loading ? <Spinner /> : null, spinnerRoot);
};

SpinnerOverlay.displayName = "SpinnerOverlay";
export default SpinnerOverlay;
